import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-center q-py-md",
  style: {"max-width":"700px","margin":"auto"}
}

import { toRefs, ref } from 'vue';
import { useQuasar } from 'quasar';

// PERSONAL COMPONENTS
import QBtnValid from '@components/form/QBtnValid.vue';
import DiagGeneric from '@components/dialog/DiagGeneric.vue';
import QDialogTemplate from '@components/template/QDialogTemplate.vue';

// Stores
import { useUiStore } from '@stores/ui';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';
import { useStorageVM } from '@viewmodel/components/qStorage.vm';

// PERSONAL LIBS
import { tailleFichier } from '@shared/lib/tools.lib';
import { DialogSizeEnum } from '@shared/enum/dialog-size.enum';
import {
  removeVideoFromCache,
  removeAllVideosFromCache,
} from '@shared/lib/service-worker.lib';

/**
 * Events
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'DialogStorageManager',
  props: {
  show: { type: Boolean, required: true, default: false },
},
  emits: ['close', 'success', 'failed'],
  setup(__props, { emit: __emit }) {

// VENDOR
const emits = __emit;

/**
 * Globals
 */
const $q = useQuasar();

/**
 * Stores
 */
const uiStore = useUiStore();

/**
 * Viewmodel
 */
const { isMobile } = useGlobalVM();
const { videoList } = useStorageVM();

/**
 * Properties
 */
const props = __props;
const { show } = toRefs(props);

/**
 * Reactive datas
 */
const loading = ref<boolean>(false);
const showConfirmDeleteAll = ref<boolean>(false);

/**
 * Methods
 */
function onClose() {
  emits('close');
}

function onDiagGenericClose() {
  showConfirmDeleteAll.value = false;
}

function removeVideo(videoId: number) {
  removeVideoFromCache([videoId]);
}

function confirmRemoveAllVideos() {
  showConfirmDeleteAll.value = true;
}

function removeAllVideos() {
  showConfirmDeleteAll.value = false;
  removeAllVideosFromCache();
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QDialogTemplate, {
      "show-dialog": _unref(show),
      title: 'Mémoire cache',
      subtitle: `Taille totale utilisée : ${_unref(tailleFichier)(
      _unref(uiStore).totalAmountOfVideoCached,
    )}`,
      maximized: _unref(isMobile),
      persistent: loading.value,
      "disable-close-button": loading.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (onClose()))
    }, {
      header: _withCtx(() => [
        _createVNode(_component_q_btn, {
          icon: "delete",
          label: !_unref(isMobile) ? 'Vider le cache' : 'Tout',
          class: "set-outline",
          title: "Vider le cache",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmRemoveAllVideos()))
        }, null, 8 /* PROPS */, ["label"])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_q_card, { flat: "" }, {
          default: _withCtx(() => [
            (_unref(videoList).length > 0)
              ? (_openBlock(), _createBlock(_component_q_list, {
                  key: 0,
                  bordered: "",
                  separator: "",
                  class: "rounded-borders page-max-width q-mx-auto"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(videoList), (video) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: video.video.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, {
                                lines: "1",
                                class: "text-uppercase"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(video.program.label), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                lines: "1",
                                class: _normalizeClass(_unref($q).dark.isActive ? 'text-white' : 'text-black')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Taille : " + _toDisplayString(_unref(tailleFichier)(video.video.fileSize)), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]),
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                lines: "1",
                                class: _normalizeClass(_unref($q).dark.isActive ? 'text-white' : 'text-black')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Fichier : " + _toDisplayString(video.video.fileName), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]),
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                lines: "1",
                                class: _normalizeClass(_unref($q).dark.isActive ? 'text-white' : 'text-black')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Mise en cache : " + _toDisplayString(video.video.cachedAt ?? 'inconnu'), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]),
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                lines: "1",
                                class: _normalizeClass(_unref($q).dark.isActive ? 'text-white' : 'text-black')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Créateur : " + _toDisplayString(video.video.creator?.username ?? 'inconnu'), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_btn, {
                                size: "12px",
                                flat: "",
                                dense: "",
                                round: "",
                                class: "set-outline",
                                icon: "folder_delete",
                                title: `Supprimer la video '${video.video.fileName}' du cache local`,
                                onClick: ($event: any) => (removeVideo(video.video.id ?? 0))
                              }, null, 8 /* PROPS */, ["title", "onClick"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, " Aucune vidéo stockée en cache "))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_q_separator),
        _createVNode(_component_q_card_actions, { align: "right" }, {
          default: _withCtx(() => [
            _createVNode(QBtnValid, {
              label: 'Fermer',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onClose())),
              disable: loading.value,
              loading: loading.value,
              "loading-label": ''
            }, null, 8 /* PROPS */, ["disable", "loading"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show-dialog", "subtitle", "maximized", "persistent", "disable-close-button"]),
    _createVNode(DiagGeneric, {
      show: showConfirmDeleteAll.value,
      title: 'Supprimer toutes les vidéos',
      message: 'Supprimer toutes les vidéos de la mémoire cache ?',
      "dialog-size": _unref(DialogSizeEnum).EXTRA_SMALL,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (onDiagGenericClose())),
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (onDiagGenericClose())),
      onValid: removeAllVideos
    }, null, 8 /* PROPS */, ["show", "dialog-size"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})